import { createFormStoreEvents } from '../create-form-store-events';

export const positionAndWeatherEvents = createFormStoreEvents('PositionAndWeatherStore');
